/*
This file exists only to service the old gift cards pages prior to WDirect
launch. It can be removed along with corresponding logic after launch.
*/

type Nav = {
  label: string
  url: string
}[]

const getOldGiftCardsNav = (): Nav => {
  const pgcBaseURL = 'https://www.westfieldgiftcards.com.au'

  return [
    {
      label: 'Digital Gift Card',
      url: '/shop/westfield-digital-gift-card',
    },
    {
      label: 'Gift Card',
      url: `${pgcBaseURL}/Online/Order/OrderCard`,
    },
    {
      label: 'Check balance',
      url: `${pgcBaseURL}/Online/Information/CardBalance`,
    },
    {
      label: 'Activate card',
      url: `${pgcBaseURL}/Online/Support/ActivateCard`,
    },
    {
      label: 'Corporate',
      url: `${pgcBaseURL}/Corporate`,
    },
    {
      label: 'Support',
      url:
        'https://support.westfield.com.au/hc/en-us/categories/360002464371-Westfield-Gift-Cards',
    },
  ]
}

export default getOldGiftCardsNav
